<template>
  <div class="st-social-buttons">
    <figure itemscope itemtype="http://schema.org/ImageObject" @click="shareFacebook">
      <img src="~images_base/st-button-facebook.svg" alt="st button facebook" title="st button facebook"/>
    </figure>
    <figure itemscope itemtype="http://schema.org/ImageObject" @click="shareTwitter">
      <img src="~images_base/st-button-twitter.svg" alt="st button twitter" title="st button twitter"/>
    </figure>
  </div>
</template>

<script>
/* globals FB */
import {mapState} from 'vuex'

export default {
  computed: mapState(['menu', 'meta']),
  methods: {
    shareFacebook () {
      FB.ui({
        method: 'feed',
        link: window.location.href
      }, function (response) {})
    },
    shareTwitter () {
      this.meta.forEach(meta => {
        if (meta.name) {
          if (meta.name === 'twitter:description') {
            var textShare = meta.content.replace(new RegExp('#', 'g'), '%23')
            textShare = textShare.replace(/'|’|‘/, '%27')
            var aUrl = this.findUrls(textShare)
            textShare = textShare.replace(aUrl[0], '', 'g')
            window.open('http://twitter.com/share?text=' + textShare + '&url=' + aUrl[0], 'twitter', '_blank')
          }
        }
      })
    },
    findUrls (text) {
      var source = (text || '').toString()
      var urlArray = []
      var matchArray
      // Regular expression to find FTP, HTTP(S) and email URLs.
      var regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&//=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g
      // Iterate through any URLs in the text.
      while ((matchArray = regexToken.exec(source)) !== null) {
        var token = matchArray[0]
        urlArray.push(token)
      }
      return urlArray
    }
  }
}
</script>
<style lang="scss">
.st-social-buttons {
  display: block;
  overflow: auto;

  figure {
    float: left;
    position: relative;
    display: inline-block;
    width: 30px;
    height: 30px;
    vertical-align: middle;
    cursor: pointer;
    margin-left: 5px;

    @include breakpoint ($d_menu_mobile) {
      width: 38px;
      height: 38px;

      img {
        opacity: 1;
      }

      &:hover {
        img {
          transform: scale(1);
        }
      }
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: transform 0.3s;
      transform: scale(0.9);
    }
  }
}
</style>
